import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import Draggable from "react-draggable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useCart } from "react-use-cart";
import toast from "react-hot-toast";
import axiosInstance, { Homeurl } from "../../axiosInstance";
import { Swiper, SwiperSlide } from "swiper/react";
import Magnifier from "../components/extra/Magnifier";

import QuantitySelector from "../components/extra/QuantitySelector";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { useBlogContext } from "../../fetchdata/BlogContext";
import { Helmet } from "react-helmet";
import getCookie from "../../helper/getCookie";
import CreateSlug from "../components/extra/CreateSlug";
import getDecryptData from "../../helper/getDecryptData";
import HeaderPage from "../components/HeaderPage";
import NavBar from "../components/NavBar";
import maplayout from "../../helper/MapStyle";
import {
  formatAMPM,
  parseNightTime,
  convertTo24Hour,
  getNightHoursOverlap,
} from "../../helper/formatAMPM";


const currentIcon = {
  url: "/assets/img/dot.svg",
  scaledSize: { width: 40, height: 40 }, // Set the desired size here (width, height)
};

const dropIcon = {
  url: "/assets/img/dotactive.svg",
  scaledSize: { width: 40, height: 40 }, // Set the desired size here (width, height)
};


const taxiIcon = {
  url: "/assets/img/taxi.webp",
  scaledSize: { width: 30, height: 66 }, // Set the desired size here (width, height)
};

const ProductSlug = () => {

const timeRef = useRef(null);
const hourRef = useRef(null);
const priceRef = useRef(null);
const getdata = getDecryptData();
const userId = getdata?._id || null;


  const [pickupMeta, setPickupMeta] = useState({
  lat: null,
  lng: null,
});

const [dropoffMeta, setDropoffMeta] = useState({
  lat: null,
  lng: null,
});


    const [selectedLocation, setSelectedLocation] = useState("");
    const [pickupLocation, setPickupLocation] = useState("");
    const [pickupFullAddress, setPickupFullAddress] = useState("");
        const [pickupLocationFinal, setPickupLocationFinal] = useState(false);
    const [dropoffLocation, setDropoffLocation] = useState("");
    const [dropoffLocationFinal, setDropoffLocationFinal] = useState(false);
    const [pickupSuggestions, setPickupSuggestions] = useState([]);
    const [dropoffSuggestions, setDropoffSuggestions] = useState([]);
    const [distance, setDistance] = useState(0); // State to hold the calculated distance
    const [getZoomLevel, setZoomLevel] = useState(15); // State to hold the calculated distance
    const [ConfirmLocation, setConfirmLocation] = useState(false);
    const [bookRide, setbookRide] = useState(false);
    const [savedAddresses, setSavedAddresses] = useState([]);
  const [Totaldistance, setTotalDistance] = useState("");
  const [duration, setDuration] = useState("");
  const [TotalPrice, setTotalPrice] = useState(0);

 let myzoom = 15;
  const applyPickupAddress = (addressData) => {
    if (!addressData?.address) return;
    const lat = addressData.latitude ?? addressData.lat ?? null;
    const lng = addressData.longitude ?? addressData.lng ?? null;

    setSelectedLocation(addressData.address);
    setPickupLocation(addressData.address);
    setPickupLocationFinal(true);
    setPickupSuggestions([]);
    setPickupMeta({
      lat,
      lng,
    });
  };

  const chooseSavedPickupAddress = (addressData) => {
    applyPickupAddress(addressData);
    const lat = addressData.latitude ?? addressData.lat ?? "";
    const lng = addressData.longitude ?? addressData.lng ?? "";
    localStorage.setItem("selectedLocation", addressData.address || "");
    localStorage.setItem("latitude", lat || "");
    localStorage.setItem("longitude", lng || "");
    toast.success("Pickup address selected");
  };

  const applyDropoffAddress = (addressData) => {
    if (!addressData?.address) return;

    setDropoffLocation(addressData.address);
    setDropoffLocationFinal(true);
    setDropoffSuggestions([]);
    setDropoffMeta({
      lat: addressData.latitude ?? addressData.lat ?? null,
      lng: addressData.longitude ?? addressData.lng ?? null,
    });
  };

  const chooseSavedDropoffAddress = (addressData) => {
    applyDropoffAddress(addressData);
    toast.success("Drop address selected");
  };

  const chooseSavedRouteAddress = (addressData) => {
    if (!pickupLocationFinal) {
      chooseSavedPickupAddress(addressData);
      return;
    }

    chooseSavedDropoffAddress(addressData);
  };

  const saveNewAddress = async (addressData, label = "Address") => {
    if (!userId || !addressData?.address) return;

    const alreadySaved = savedAddresses.some(
      (savedAddress) =>
        (savedAddress.address || "").trim().toLowerCase() ===
        addressData.address.trim().toLowerCase()
    );

    if (alreadySaved) return;

    try {
      const { data } = await axiosInstance.post(`/user-addresses/${userId}`, {
        label,
        address: addressData.address,
        pickupFullAddress:
          addressData.pickupFullAddress ||
          addressData.fullAddress ||
          addressData.address,
        latitude: addressData.latitude ?? addressData.lat ?? "",
        longitude: addressData.longitude ?? addressData.lng ?? "",
        isDefault: label === "Pickup",
      });

      setSavedAddresses(data.addresses || []);
      toast.success(`${label} saved`);
    } catch (error) {
      console.error("Error saving address:", error);
    }
  };

  const saveNewPickupAddress = (addressData) => saveNewAddress(addressData, "Pickup");
  const saveNewDropoffAddress = (addressData) => saveNewAddress(addressData, "Drop");

  const loadUserProfilePickupAddress = async () => {
    if (!userId) return false;

    try {
      const { data } = await axiosInstance.post("/auth-user", { id: userId });
      const existingUser = data?.existingUser;
      const fullAddress = existingUser?.address || "";

      if (!fullAddress) return false;

      setPickupFullAddress(fullAddress);
      return true;
    } catch (error) {
      console.error("Error loading user profile pickup address:", error);
      return false;
    }
  };

  useEffect(() => {
    const loadPickupAddress = async () => {
      if (userId) {
        try {
          const { data } = await axiosInstance.get(`/user-addresses/${userId}`);
          const addresses = data.addresses || [];
          setSavedAddresses(addresses);

          await loadUserProfilePickupAddress();

          const defaultAddress =
            addresses.find((address) => address.isDefault) || addresses[0];

          if (defaultAddress?.address) {
            applyPickupAddress(defaultAddress);
            const lat = defaultAddress.latitude ?? defaultAddress.lat ?? "";
            const lng = defaultAddress.longitude ?? defaultAddress.lng ?? "";
            localStorage.setItem("selectedLocation", defaultAddress.address);
            localStorage.setItem("latitude", lat || "");
            localStorage.setItem("longitude", lng || "");
            return;
          }
        } catch (error) {
          console.error("Error loading saved pickup address:", error);
          await loadUserProfilePickupAddress();
        }
      }

      const location = localStorage.getItem("selectedLocation");
      const latitude = localStorage.getItem("latitude");
      const longitude = localStorage.getItem("longitude");

      if (location) {
        applyPickupAddress({
          address: location,
          latitude,
          longitude,
        });
      }
    };

    loadPickupAddress();
  }, [userId]);

  // Function to initialize the map
  const initMap = (myzoom) => {
    const map = new window.google.maps.Map(document.getElementById("map"), {
      center: { lat: 0, lng: 0 }, // Default center
      zoom: myzoom ? myzoom : 15, // Default zoom level
      disableDefaultUI: true, // Disable default UI controls
      styles: maplayout,
    });

    if (selectedLocation !== "" && dropoffLocation !== "") {
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer = new window.google.maps.DirectionsRenderer({
        map,
        polylineOptions: {
          strokeColor: "#0D1722", // Blue color
        },
        suppressMarkers: true, // Suppress default markers
      });

      const request = {
        origin: selectedLocation,
        destination: dropoffLocation,
        travelMode: "DRIVING",
      };

      directionsService.route(request, (result, status) => {
        if (status === "OK") {
          directionsRenderer.setDirections(result);

          // Custom markers for start and end
          const startMarker = new window.google.maps.Marker({
            position: result.routes[0].legs[0].start_location,

            map,
            icon: currentIcon,
          });

          const endMarker = new window.google.maps.Marker({
            position:
              result.routes[0].legs[result.routes[0].legs.length - 1]
                .end_location,
            map,
            // label: 'E', // Custom label for end marker
            icon: dropIcon,
          });

          // Calculate total distance
          let totalDistance = 0;
          result.routes[0].legs.forEach((leg) => {
            totalDistance += leg.distance.value;
          });
          totalDistance /= 1000; // Convert meters to kilometers

          // Create custom overlay for total distance
          const distanceOverlay = new window.google.maps.OverlayView();
          distanceOverlay.onAdd = function () {
            const div = document.createElement("div");
            div.style.backgroundColor = "#0D1722";
            div.style.color = "white";
            div.style.padding = "10px";
            div.style.borderRadius = "5px";
            div.style.position = "absolute";
            div.style.top = "10px"; // Adjust top position as needed
            div.style.left = "10px"; // Adjust left position as needed
            div.textContent = `Total Distance: ${totalDistance.toFixed(2)} km`;
            this.getPanes().floatPane.appendChild(div);
            this.div_ = div;
          };
          distanceOverlay.draw = function () { };
          distanceOverlay.setMap(map);
        } else {
          console.error("Error rendering directions:", status);
        }
      });
    }

    if (selectedLocation !== "") {
      // Geocode selected location and display marker on the map
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: selectedLocation }, (results, status) => {
        if (status === "OK") {
          map.setCenter(results[0].geometry.location);
          new window.google.maps.Marker({
            map,
            position: results[0].geometry.location,
            icon: taxiIcon, // Set the car image as marker icon
            scaledSize: new window.google.maps.Size(0, 0), // Set the size here (width, height)
          });
        } else {
          console.error(
            "Geocode was not successful for the following reason:",
            status
          );
        }
      });
    }

    //    // Add marker for drop-off location
    //    if (dropoffLocation !== '') {
    //     const geocoder = new window.google.maps.Geocoder();
    //     geocoder.geocode({ address: dropoffLocation }, (results, status) => {
    //         if (status === 'OK') {
    //             new window.google.maps.Marker({
    //                 map,
    //                 position: results[0].geometry.location,
    //                 icon: dropIcon, // Set the car image as marker icon
    //                 scaledSize: new window.google.maps.Size(0, 0), // Set the size here (width, height)
    //               });
    //         } else {
    //             console.error('Geocode was not successful for the following reason:', status);
    //         }
    //     });
    // }
  };

  const loadMapScript = (zoom) => {
    if (selectedLocation !== "") {
      const scriptId = "google-maps-script";

      if (
        !document.getElementById(scriptId) ||
        !document.querySelector(
          `script[src*="https://maps.googleapis.com/maps/api/js"]`
        )
      ) {
        const script = document.createElement("script");
        script.id = scriptId;
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDYsdaR0zrPsBDeuyCKFH_4PuCUyWcQ2mE&libraries=geometry,places`;
        script.onload = () => {
          initMap(zoom);
        };
        document.body.appendChild(script);
      } else {
        initMap(zoom);
      }
    }
  };

  const ChangeConfirm = () => {
    setConfirmLocation(false);
    console.log(ConfirmLocation);
  };

  const handlePickupChange_old = (e) => {
    const value = e.target.value;
    setPickupLocation(value);
    if (value.trim() !== "") {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: value }, (predictions) => {
        if (predictions) {
          const suggestedPlaces = predictions.map((prediction) => prediction);
          setPickupSuggestions(suggestedPlaces);
          console.log(suggestedPlaces); 
        }
      });
    } else {
      setPickupSuggestions([]);
    }
  };



 const handlePickupChange = (e) => {
  const value = e.target.value;
  setPickupLocation(value);
  setSelectedLocation(value);
  setPickupLocationFinal(false);
  setPickupMeta({
    lat: null,
    lng: null,
  });

  if (value.trim() !== "") {
    const autoService = new window.google.maps.places.AutocompleteService();

    autoService.getPlacePredictions({ input: value }, (predictions) => {
      if (predictions && predictions.length > 0) {
        const placesService = new window.google.maps.places.PlacesService(
          document.createElement("div")
        );

        // Create array of promises to fetch details for each prediction
        const detailedPlacesPromises = predictions.map((prediction) => {
          return new Promise((resolve) => {
            placesService.getDetails(
              {
                placeId: prediction.place_id,
                fields: ["geometry", "formatted_address", "name"],
              },
              (place, status) => {
                if (
                  status ===
                  window.google.maps.places.PlacesServiceStatus.OK
                ) {
                  resolve({
                    ...prediction,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    address: place.formatted_address,
                  });
                } else {
                  resolve(null);
                }
              }
            );
          });
        });

        Promise.all(detailedPlacesPromises).then((results) => {
          const filteredResults = results.filter(Boolean);
          setPickupSuggestions(filteredResults);
          console.log(filteredResults);
        });
      }
    });
  } else {
    setPickupSuggestions([]);
  }
};
 
  const handleDropoffChange_old = (e) => {
    console.log();
    const value = e.target.value;
    setDropoffLocation(value);
     if (value.trim() !== "") {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: value }, (predictions) => {
        if (predictions) {
          const suggestedPlaces = predictions.map((prediction) => prediction);
          setDropoffSuggestions(suggestedPlaces);
        }
      });
    } else {
      setDropoffSuggestions([]);
    }
  };

  const handleDropoffChange = (e) => {
  const value = e.target.value;
  setDropoffLocation(value);
  setDropoffLocationFinal(false);
  setDropoffMeta({
    lat: null,
    lng: null,
  });

  if (value.trim() !== "") {
    const autoService = new window.google.maps.places.AutocompleteService();

    autoService.getPlacePredictions({ input: value }, (predictions) => {
      if (predictions && predictions.length > 0) {
        const placesService = new window.google.maps.places.PlacesService(
          document.createElement("div")
        );

        const detailedPlacesPromises = predictions.map((prediction) => {
          return new Promise((resolve) => {
            placesService.getDetails(
              {
                placeId: prediction.place_id,
                fields: ["geometry", "formatted_address", "name"],
              },
              (place, status) => {
                if (
                  status ===
                  window.google.maps.places.PlacesServiceStatus.OK
                ) {
                  resolve({
                    ...prediction,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                    address: place.formatted_address,
                  });
                } else {
                  resolve(null);
                }
              }
            );
          });
        });

        Promise.all(detailedPlacesPromises).then((results) => {
          const filteredResults = results.filter(Boolean);
          setDropoffSuggestions(filteredResults);
          console.log(filteredResults);
        });
      }
    });
  } else {
    setDropoffSuggestions([]);
  }
};

    const [startSearching, setStartSearching] = useState(false);


  const handleSearchLocationClick = async () => {
   
    try {
       setStartSearching(true);
      const updatelocation = {
        pickup: selectedLocation,
        dropoff: dropoffLocation,
      };
 
      const response =  await toast.promise(
      axiosInstance.post("/api/find-distance/", updatelocation),
      {
        loading: "Searching Ride...",
        success: "Searching Ride Successfully!",
        error: "Failed to searching ride",
      }
    );
 

if(response.data.success){
      saveNewPickupAddress({
        address: selectedLocation,
        pickupFullAddress: pickupFullAddress.trim() || selectedLocation,
        latitude: pickupMeta?.lat,
        longitude: pickupMeta?.lng,
      });
      saveNewDropoffAddress({
        address: dropoffLocation,
        latitude: dropoffMeta?.lat,
        longitude: dropoffMeta?.lng,
      });
 setConfirmLocation(true);
      const distanceValue =
        response.data.data.rows[0].elements[0].distance.text;
      const durationValue =
        response.data.data.rows[0].elements[0].duration.text;
      setTotalDistance(distanceValue);
      setDuration(durationValue);

      setZoomLevel(15);

      console.log("distanceValue", response.data.data);

      const distanceInKM = parseFloat(
        distanceValue.replace(" km", "").replace(",", "")
      );

      // Calculate zoom level based on distance
      const scale = Math.pow(2, 20);
      let zoomLevel = Math.round(
        Math.log(scale / (distanceInKM * 1000)) / Math.LN2
      );

      // Add a fixed value to the calculated zoom level for more zoom
      zoomLevel += 5; // Adjust this value as needed to achieve the desired zoom level

      loadMapScript(zoomLevel); 
      console.log("zoomLevelclick", zoomLevel);
 
} 

    } catch (error) {
      console.error("Error fetching distance:", error);
       setConfirmLocation(false);
    }finally{
       setStartSearching(false);
    }
  };

 


  useEffect(() => {
    loadMapScript(getZoomLevel);
  }, []);

  // Function to handle click on search result
  const handleSearchPickupClick = (result) => {
    console.log('resultresultresultresult',result)
    toast.success("Location Update");
    const address = result.address || result.description;
    setPickupSuggestions([]);
    setSelectedLocation(address);
    setPickupLocation(address);
    setPickupLocationFinal(true);
       setPickupMeta({
  lat: result?.lat,
  lng: result?.lng,
})
    localStorage.setItem("selectedLocation", address || "");
    localStorage.setItem("latitude", result?.lat || "");
    localStorage.setItem("longitude", result?.lng || "");
    saveNewPickupAddress({
      address,
      pickupFullAddress: pickupFullAddress.trim(),
      latitude: result?.lat,
      longitude: result?.lng,
    });
    // localStorage.setItem("selectedLocation", result.description);
  };

  // Function to handle click on search result
  const handleSearchDropClick = async (result) => {
    // toast.success('Location Update');
    const address = result.address || result.description;
    setDropoffSuggestions([]);
    setDropoffLocation(address);
    setDropoffLocationFinal(true);
    setDropoffMeta({
  lat: result?.lat,
  lng: result?.lng,
})
console.log('resultresultresult',result)
    saveNewDropoffAddress({
      address,
      latitude: result?.lat,
      longitude: result?.lng,
    });
    // calculateDistanceBetweenLocations(result.description);
    //  initMap();
    // useEffect to trigger distance calculation when pickupLocation or dropoffLocation changes
  };

  useEffect(() => {
    loadMapScript();
  }, [selectedLocation]);

  const clearPickup = () => {
    setPickupLocation("");
    setSelectedLocation("");
    setPickupLocationFinal(false);
    setPickupSuggestions([]);
    setPickupMeta({
      lat: null,
      lng: null,
    });
  };

  const clearDrop = () => {
    setDropoffLocation("");
    setDropoffLocationFinal(false);
    setDropoffSuggestions([]);
    setDropoffMeta({
      lat: null,
      lng: null,
    });
  };


   const tableRef = useRef(null);
  
  
    const [tableData, setTableData] = useState({
      headers: [],
      rows: [],
    });
  


  const navigate = useNavigate();

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);

  // const userId = localStorage.getItem('userId');

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

  const [SubmitWishlist, setWishlistLoading] = useState(true); // Add loading state

  const [SubmitCompare, setCompareLoading] = useState(true); // Add loading state

  const {
    Headers,
    isHeader,
    addItemToCart,
    cartItems,
    promoCodeInfo,
    applyPromoCode,
    removePromoCode,
    mypromoCode,
    updateItemQuantity, IsUserData,dataAuth 
  } = useBlogContext();

  const [selectedValues, setSelectedValues] = useState([]);

  const [ValuesVariant, setValuesVariant] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [selectedCombination, setSelectedCombination] = useState({});

  const [ProductsRegular, setProductsRegular] = useState(0);
  const [ProductsSale, setProductsSale] = useState(0);
  const [productPromoCode, setProductPromoCode] = useState("");

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const { id, slug } = useParams();

  const [formData, setFormData] = useState({
    userId: userId || "",
    productId: id,
    rating: "",
    comment: "",
    username: IsUserData.username,
  });




  useEffect(() => {
    setIsLoading(true);
    setIsProducts(true);
    // Update the productId in the formData when id changes
    setFormData((prevState) => ({
      ...prevState,
      productId: id,
      rating: "",
      comment: "",
    }));
    dataAuth();
   }, [id]); // This useEffect will re-run whenever id changes

  
  const [selectedColor, setSelectedColor] = useState(""); // State to hold the selected color

  const [pdfBase64, setPdfBase64] = useState(""); // State to hold the PDF as Base64 string

  const [SelectedSizes, setSelectedSizes] = useState({});
  const [TotalQuantity, setTotalQuantity] = useState(1);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [thumbsVarSwiper, setThumbsVarSwiper] = useState(null);

  const [isOpenReview, setIsOpenReview] = useState(false);
  const [activeData, setActiveData] = useState([]);


    const [ChooseDateTime, setChooseDateTime] = useState(false);


  const toggleReviewPopup = () => {
    if (userId && getdata) {
      setIsOpenReview(!isOpenReview);
    } else {
      toast.error("Please Login First", TotalQuantity);
    }
  };

  const getProducts = async () => {
       const decryptdatajson = await getDecryptData();
            if (decryptdatajson && decryptdatajson?._id) {
     
              setEnquireData((prevData) => ({
                ...prevData,
                fullname: decryptdatajson.username,
                email: decryptdatajson.email,
                phone: decryptdatajson.phone,
    
              })); // Clear form fields
            }
            
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
         
           setEnquireData((prevData) => ({
            ...prevData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })); // Clear form fields

          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },
     
      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      return null;
     }
     


  }, [slug]);

   

  const handleAddToCart_old = async (product, buy) => {
 

    if(ChooseDateTime){
    setChooseDateTime(false);

    }else{
    setChooseDateTime(true);
    return null;
    }


    // if (!selectedColor) {
    //   toast.error("Please select a color");
    // } else if (!TotalQuantity) {
    //   toast.error("Please select a Quantity", TotalQuantity);
    // } else { }

    const existingProduct = cartItems.find((item) => item.id === product.id);
    if (existingProduct) {
      // const updatedQuantity = existingProduct.quantity + 1;
      const updatedQuantity = TotalQuantity;
      console.log("updatedQuantity", updatedQuantity);

      updateItemQuantity(
        existingProduct.id,
        cartItems.find((item) => item.id === existingProduct.id).quantity +
        updatedQuantity
      );

      if (buy) {
        navigate("/checkout");
      }
      toast.success("Product quantity updated in cart");
    } else {
      await addItemToCart(
        { ...product, color: selectedColor, TotalQuantity },
        TotalQuantity
      );

      // updateItemQuantity(product.id, updatedQuantity);

      if (buy) {
        navigate("/checkout");
      }
      // toast.success("Product Added To Cart");
    }

  };

  
  const handleAddToCart = async (product) => {
 

    if(ChooseDateTime){
    setChooseDateTime(false);
return null;
    } 

    await addItemToCart(
        {...product} 
      );
 
      toast.success('Checkout...')
        navigate("/checkout");
 
    

  };

  const handleBuyNow = (product) => {
    const buy = TotalQuantity;
    handleAddToCart(product, buy);
  };

  const [frontImage, setFrontImage] = useState(null);
  const [overlayImage, setOverlayImage] = useState(null);
  const overlayRef = useRef(null);
  const [overlayPosition, setOverlayPosition] = useState({ x: 0, y: 0 });
  const [overlaySize, setOverlaySize] = useState({ width: 200, height: 200 });
  const [isResizing, setIsResizing] = useState(false);
  const [resizeStart, setResizeStart] = useState({ x: 0, y: 0 });
  const [resizeStartSize, setResizeStartSize] = useState({
    width: 0,
    height: 0,
  });

  const [text, setText] = useState("");
  const [textPosition, setTextPosition] = useState({ x: 10, y: 10 });
  const [isTextDragging, setIsTextDragging] = useState(false);
  const [textColor, setTextColor] = useState("#000000");
  const [textSize, setTextSize] = useState(16);

  const [loading, setLoading] = useState(true); // Add loading state
  const [Image, setImage] = useState("");
  const [Specifications, setspecifications] = useState([]);

  const [mainImage, setMainImage] = useState("");

  const [Product, setProduct] = useState({});
  const [Attr, setAttr] = useState([]);
  const [sizeQuantities, setSizeQuantities] = useState({});
  const [variations, setVariations] = useState([]);
  const [Images, SetImages] = useState([]);

  const [variationsSize, setVariationsSize] = useState([]);
  const [Testimonial, setTestimonial] = useState([]);

  const [Varloading, SetVarLoading] = useState(true); // Add loading state
  const [ratings, setRatings] = useState([]);
  const [totalRating, settotalRating] = useState("");
  const [averageRating, setaverageRating] = useState("");
  const [HSNvariations, setHSNVariations] = useState({});
  const [selectedVariation, setSelectedVariation] = useState(null);

  const [variationsmap, setVariationsmap] = useState([]);
  const [prohsn, setprohsn] = useState("");

  const [activevariations, setactiveVariations] = useState({});

  const handleSmallImageClick = (newImageSrc) => {
    setFrontImage(newImageSrc);
  };

  const [enquireData, setEnquireData] = useState([]);
  const [dateTimeData, setDateTimeData] = useState([]);

  const getProduct = async () => {
    window.scrollTo(0, 0);
    setLoading(true); // Set loading to false when data is fetched
    SetVarLoading(true);

    console.log('__PRELOADED_DATA__', window.__PRELOADED_DATA__?.slug, slug);
    if (window.__PRELOADED_DATA__?.slug !== slug || window.__PRELOADED_DATA__ === undefined) {
      try {
        const { data } = await axiosInstance.get(`/user-product-slug/${slug}`);
        setProduct(data.Product);
        // setVariations(data.Product.variations.Color || []);
        // setVariationsSize(data.Product.variations.Size);
        SetImages(data.Product.images);
        setFrontImage(data.Product.pImage);
        setspecifications(data.Product.specifications.specifications || []);
        setSelectedValues(data.Product.variations);
        setProductCoverage(data.Product.coverage);
        setEnquireData((prevData) => ({
          ...prevData,
          service: data.Product?.title,
          category: data.Product?.Category,
        })); // Clear form fields
         setprohsn(data.Product.hsn || "");
        setActiveData(data.Product.variations);
        setValuesVariant(data.Product?.variant_products);
        setProductsRegular(data.Product?.regularPrice || 0);
        setProductsSale(data.Product?.salePrice || 0);
        setTestimonial(data.Product?.testimonials || []);
        const extraContent =
  Array.isArray(data.Product?.extra_content) &&
  data.Product.extra_content.length > 0 &&
  Array.isArray(data.Product.extra_content[0]?.headers) &&
  Array.isArray(data.Product.extra_content[0]?.rows)
    ? data.Product.extra_content[0]
    : { headers: [], rows: [] };

setTableData(extraContent);

        const firstVisibleProduct = data.Product?.variant_products && data.Product?.variant_products.find(
          (product) => product.visible === true
        );

        if (firstVisibleProduct) {
          const {
            regular_price,
            sale_price,
            qty,
            visible,
            images,
            ...filteredProduct
          } = firstVisibleProduct;

          setSelectedCombination(filteredProduct);

          console.log("firstVisibleProduct", filteredProduct);
        
        }
          getRating(data.Product._id);
      } catch (error) {
        console.error("Error getting product:", error);
        navigate("/404");
      } finally {
        setLoading(false); // Set loading to false when data is fetched
        SetVarLoading(false);
        console.log("Image", Image);
      }
    } else {
      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      setIsLoading(false);

      setProduct(window.__PRELOADED_DATA__);
      // setVariations(data.Product.variations.Color || []);
      // setVariationsSize(data.Product.variations.Size);
      SetImages(window.__PRELOADED_DATA__.images);
      setFrontImage(window.__PRELOADED_DATA__.pImage);
      setspecifications(window.__PRELOADED_DATA__.specifications.specifications || []);
      setSelectedValues(window.__PRELOADED_DATA__.variations);
      setTestimonial(window.__PRELOADED_DATA__.testimonials || []);

      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__?.title,
      })); // Clear form fields

      // console.log("product data", data);
      setprohsn(window.__PRELOADED_DATA__.hsn || "");
      setActiveData(window.__PRELOADED_DATA__.variations);
      setValuesVariant(window.__PRELOADED_DATA__?.variant_products);
      setProductsRegular(window.__PRELOADED_DATA__?.regularPrice || 0);
      setProductsSale(window.__PRELOADED_DATA__?.salePrice || 0);
      const firstVisibleProduct = window.__PRELOADED_DATA__?.variant_products.find(
        (product) => product.visible === true
      );

      if (firstVisibleProduct) {
        const {
          regular_price,
          sale_price,
          qty,
          visible,
          images,
          ...filteredProduct
        } = firstVisibleProduct;

        setSelectedCombination(filteredProduct);

        console.log("firstVisibleProduct", filteredProduct);
      }

      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      getRating();
    }


  };

useEffect(() => {
  const table = tableRef.current;
  if (!table) return;
  table.innerHTML = "";

  // Create table header
  const thead = document.createElement("thead");
  const headerRow = document.createElement("tr");

  tableData.headers.forEach((header) => {
    const th = document.createElement("th");
    th.className = "bg-light"; // Add bg-light class
    th.innerText = header;
    headerRow.appendChild(th);
  });



  thead.appendChild(headerRow);
  table.appendChild(thead);

  // Create table body
  const tbody = document.createElement("tbody");

  tableData.rows.forEach((row) => {
    const tr = document.createElement("tr");

    row.values.forEach((value) => {
      const td = document.createElement("td");
      td.innerText = value;
      tr.appendChild(td);
    });

 
    tbody.appendChild(tr);
  });

  table.appendChild(tbody);
}, [tableData, loading]);




  const getRating = async (id) => {
 

    try {
    
      const { data } = await axiosInstance.get(`/view-product-rating/${id}`);
      console.log("rating", data);
      const myrating = data.productRatings.reverse();
      setRatings(myrating);
      hasUserReviewed();

      // Calculate total rating
      const totalRating = data.productRatings.length;
      settotalRating(totalRating);

      // Calculate average rating
      const averageRating =
        totalRating > 0
          ? data.productRatings.reduce(
            (acc, rating) => acc + rating.rating,
            0
          ) / totalRating
          : 0;
      setaverageRating(averageRating);


    } catch (error) {
      console.error("Error fetching rating:", error);
   
        
      }
  };
  const hasUserReviewed = () => {
    const reviewedRating = ratings.find((rating) => rating.userId === userId);
    const hasReviewed = !!reviewedRating; // Convert to boolean
    // console.log('User has reviewed:', hasReviewed);
    return hasReviewed;
  };

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

  const handleIncrement = (stock) => {
    if (TotalQuantity <= stock) {
      // Check input length before updating

      setTotalQuantity(TotalQuantity + 1);
    } else {
      toast.error("Product out of stock. ");
    }
  };

  const handleDecrement = () => {
    if (TotalQuantity > 1) {
      setTotalQuantity(TotalQuantity - 1);
    }
  };

  const handleQuantityChange = (event) => {
    const newQuantity = parseInt(event.target.value);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      setTotalQuantity(newQuantity);
    }
  };

  useEffect(() => {
    setVariationsmap([]); 
    getProduct();
    getAttribute();
  }, [slug]);

  // product zoom js

  const [isZoomed, setIsZoomed] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const handleMouseEnter = (product) => {
    setIsZoomed(true);
    setHoveredProduct(product);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
    setHoveredProduct(null);
  };

  const handleMouseMove = (e) => {
    setCursorPosition({
      x: (e.nativeEvent.offsetX / e.target.offsetWidth) * 100,
      y: (e.nativeEvent.offsetY / e.target.offsetHeight) * 100,
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const AddWhishlistData = async () => {
    setWishlistLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setWishlistLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-wishlist", formData);
        toast.success("wishlist Added successfully!");
      } catch (error) {
        console.error("Error on wishlist added:", error);
        toast.error(error.response.data.message);
      } finally {
        setWishlistLoading(true);
      }
    }
  };

  const AddCompareData = async () => {
    setCompareLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setCompareLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-compare", formData);
        toast.success("Comparsion Added successfully!");
      } catch (error) {
        console.error("Error on compare added:", error);
        toast.error(error.response.data.message);
      } finally {
        setCompareLoading(true);
      }
    }
  };

  const submitData = async () => {
    setSubmitLoading(false);

    if (!userId) {
      toast.error("Please Login First");
      setSubmitLoading(true);
      return;
    } else {
      if(  !formData.username && !IsUserData.username){
          toast.error("Please enter full Name");
      setSubmitLoading(true);
      return;
      }
      if (formData.rating !== "" || formData.comment !== "") {
        const mydata = {
          rating : formData.rating,
          comment : formData.comment,
          userId : userId,
          productId : Product._id,
          username :  formData.username ,
        }
        try {
          await axiosInstance.post("/add-rating", mydata);
          toggleReviewPopup();
          toast.success("Rating Added successfully!");
          
  const timer = setTimeout(() => {
      window.location.reload();
    }, 100);   
     return () => clearTimeout(timer);

        } catch (error) {
          console.error("Error on rating added:", error);
          toast.error(error.response.data.message);
          setRatings([]);
        } finally {
          setSubmitLoading(true);
        }
      } else {
        toast.error("Please Fill All Fields");
        setSubmitLoading(true);
      }
    }
  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  }

  const [MatchImages, setMatchImages] = useState([]);
  const [ProductVariantName, setProductVariantName] = useState("");
  const [ProductuniqueId, setProductuniqueId] = useState("");
  const [ProductCoverage, setProductCoverage] = useState([]);


  // Function to handle button click and update selected variant
  // Function to handle button click and update selected variant
  const handleVariantButtonClick_old = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };
    setSelectedCombination(newSelectedCombination);
  };

  const handleVariantButtonClick = (name, value) => {
 
  // Update selected combination
  const newSelectedCombination = { ...selectedCombination, [name]: value };

  console.log('newSelectedCombination',newSelectedCombination);
  setSelectedCombination(newSelectedCombination);
};

  useEffect(() => {
    const filteredVariants = ValuesVariant.filter(
      (variant) => variant.visible === true
    );

    console.log("Filtered Variants:", filteredVariants);

    const allRowsSelected = selectedValues.every((variant) =>
      variant.value.some((val) => selectedCombination[variant.name] === val)
    );

    const variantsWithId = filteredVariants.map((variant, index) => ({
      ...variant,
      id: index + 1, // or use uuidv4() for unique id

    }));

    console.log("All Rows Selected:", allRowsSelected);

    if (allRowsSelected) {
      const matchedVariant = variantsWithId.find((variant) =>
        Object.keys(selectedCombination).every(
          (key) => variant[key] === selectedCombination[key]
        )
      );

      console.log("Matched Variant:", matchedVariant);

      if (matchedVariant) {
  const location = localStorage.getItem("location"); // Get location from localStorage

  // Add safety check for ProductCoverage
  const match = Array.isArray(ProductCoverage)
    ? ProductCoverage.find(item => item.city === location)
    : null;

  const coveragePrice = match ? Number(match.price) : 0;

  const regularPrice = Number(matchedVariant.regular_price);
  const salePrice = Number(matchedVariant.sale_price);

  setProductsRegular(regularPrice + coveragePrice);
  setProductsSale(salePrice + coveragePrice);

  console.log("Price:", matchedVariant.regular_price);
  console.log("Sale Price:", matchedVariant.sale_price);

  setProductuniqueId(matchedVariant.id);
  setMatchImages(matchedVariant.images);

  const { regular_price, sale_price, qty, visible, images, id, ...rest } = matchedVariant;

  const restString = `[ ${Object.entries(rest)
    .map(([key, value]) => `${key}: ${value}`)
    .join(", ")} ]`;
  setProductVariantName(" " + restString);
} else {
  console.log("No matching variant found for the selected combination.");
}

    } else {
      console.log("Not all combinations selected.");
    }
  }, [selectedCombination]);

  const removeSelectedFillter = () => {
    setSelectedCombination([]);
    setMatchImages([]);
    setProductsRegular(0);
    setProductsSale(0);
    setProductVariantName("");
    toast.success("Attribute Cleared Successfully");
  };

  const isCombinationPossible = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };

    const visibleVariants = ValuesVariant.filter((variant) => variant.visible);

    return visibleVariants.some((variant) =>
      Object.keys(newSelectedCombination).every(
        (key) =>
          !newSelectedCombination[key] ||
          variant[key] === newSelectedCombination[key]
      )
    );
  };

  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  const [StepForm, setStepForm] = useState(0);

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };


  const enquireToggle = () => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
    }
  };

    const dateTimeToggle = () => {
    if (ChooseDateTime) {
      setChooseDateTime(false);
    } else {
      setChooseDateTime(true);
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);


 
   const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits
      if (newValue.length > 13) {
        newValue = newValue.slice(0, 13); // Limit to 10 digits
      }
    }

  // Capitalize text for the 'username' field
  if (name === "state") {
    const selectedState = data.find((state) => state._id === newValue);
    if (selectedState) {
      setFilteredCities(selectedState.cities);
      setEnquireData((prevData) => ({
        ...prevData,
        statename: selectedState.name,
        city: "",
      }));
    }
    console.log("selectedState", selectedState, newValue, data);
  }

    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

    const handleDateTimeChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }
 
    // Update form data with the new value
    setDateTimeData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };


  const handleSendEnquire = async () => {
    console.log('enquireData',enquireData)

    const fields = [
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "address", message: "Please enter address" },
      { name: "pincode", message: "Please enter Pincode" },
      { name: "state", message: "Please enter state" },
      { name: "city", message: "Please enter city" },
      { name: "bookingDate", message: "Please enter booking date" },
      { name: "bookingTime", message: "Please enter booking time" },
      { name: "requirement", message: "Please enter address" },
    ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setEnquireStatus(false);
        return;
      }
    }


    
         
    try {
      setEnquireStatus(true);
      await toast.promise(axiosInstance.post(`/send-enquire`, enquireData), {
        loading: "Enquire Submiting...", // Loading message
        success: "Enquire Submited Successfully!", // Success message
        error: "Failed to Submit Enquire.", // Error message
      });
      enquireToggle();
      setEnquireData((prevData) => ({
        ...prevData,
        fullname: "",
        email: "",
        phone: "",
        service: "",
        QTY: "",
      })); // Clear form fields
    } catch (error) {
      console.error("Failed to send email:", error);
      // toast.error('Failed to send email');
    } finally {
      setEnquireStatus(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, []);  


    const [ExtendDate, setExtendDate] = useState(6);
    const [StartTime, setStartTime] = useState( "T10:00:00");
    const [EndTime, setEndTime] = useState("T20:00:00");
    const [TimeGap, setTimeGap] = useState(30);
    const [roundOffTime, setroundOffTime] = useState('Yes');
    const [startingHour, setStartingHour] = useState(1);
    const [NightCharges, setNightCharges] = useState(0);

 
 
 const generateDates = () => {
  const days = [];
  const today = new Date();

  for (let i = 0; i < ExtendDate ; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    const options = { weekday: "short", day: "2-digit", month: "short" };
    days.push({
      label: date.toLocaleDateString("en-IN", options), // e.g. Wed, 09 Jul
      value: date.toISOString().split("T")[0], // yyyy-mm-dd
    });
  }
  return days;
};

const roundToNextHalfHour = (date) => {
  const d = new Date(date);
  d.setMinutes(d.getMinutes() + (30 - (d.getMinutes() % 30)));
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d;
};

const generateTimeSlots = (dateStr) => {
  const slots = [];
  const isToday = new Date().toISOString().split("T")[0] === dateStr;

  const start = new Date();
  if (isToday) {
     // start.setHours(start.getHours() + startingHour);
    start.setMinutes(start.getMinutes() + startingHour);
    const roundedStart = ( roundOffTime === "Yes" ? roundToNextHalfHour(start) : start.setMinutes(start.getMinutes() + 1) );
    let current = new Date(roundedStart);
        const end = new Date(dateStr + EndTime);

    while (current <= end ) {
      slots.push(formatAMPM(current));
      current.setMinutes(current.getMinutes() + TimeGap);
    }
  } else {
    let current = new Date(dateStr + StartTime);
    const end = new Date(dateStr + EndTime);
    while (current <= end) {
      slots.push(formatAMPM(current));
      current.setMinutes(current.getMinutes() + TimeGap);
    }
  }

  return slots;
};
 

// const [selectedDate, setSelectedDate] = useState(generateDates()[0].value);
const [selectedDate, setSelectedDate] = useState(null);

const [timeSlots, setTimeSlots] = useState(generateTimeSlots(generateDates()[0].value));
const [selectedTime, setSelectedTime] = useState("");
const [selectedHour, setSelectedHour] = useState("");
const [selectedCarType, setSelectedCarType] = useState("");
const [alternativePhone, setAlternativePhone] = useState("");
const [receiverPhoneDraft, setReceiverPhoneDraft] = useState("");
const [showReceiverDetails, setShowReceiverDetails] = useState(false);

const carTypeOptions = [
  { value: "Manual", label: "Manual" },
  { value: "Automatic", label: "Automatic" },
  { value: "EV", label: "EV" },
  { value: "Commercial Heavy", label: "Commercial Heavy" },
];

const selectChangeHour = (hr) => { 
   setSelectedHour(`${hr}`); 
}

const openReceiverDetails = () => {
  setReceiverPhoneDraft(alternativePhone);
  setShowReceiverDetails(true);
};

const saveReceiverDetails = () => {
  setAlternativePhone(receiverPhoneDraft.trim());
  setShowReceiverDetails(false);
};


// here is the main logic where all caluation day whise and hr wise 
// const getApproxPrice = () => {
//   const selectedHourNumber = Number(selectedHour || 0);
//   const distanceInKm =
//     parseFloat((Totaldistance || "0").replace(/[^\d.]/g, "")) || 0;

//   if (!Product) return 0;

//   if (Product.logic === 2) {
//     return Math.round(distanceInKm * (Headers?.kmCharges || 0) + (NightCharges || 0));
//   }

//   if (!selectedHourNumber || !selectedDate) return 0;

//   if (Product.day && Product.day !== 0) {
//     return Math.round(
//       selectedHourNumber === 0.5
//         ? ProductsSale + NightCharges
//         : (selectedHourNumber / 24) * Product.day + NightCharges
//     );
//   }

//   return Math.round(
//     selectedHourNumber === 0.5
//       ? ProductsSale + NightCharges
//       : ProductsSale + ((selectedHourNumber * 60 - 30) * Product.minPrice) + NightCharges
//   );
// };



const calculateHourlyPrice = (hourNumber) => {
  if (!hourNumber) return 0;
  const baseMinutes = Headers?.serviceHour || 0;
  const extraMinutes = Math.max(0, (hourNumber * 60) - baseMinutes);
  return ProductsSale + (extraMinutes * Product.minPrice) + NightCharges;
};

const getApproxPrice = () => {
  const selectedHourNumber = Number(selectedHour || 0);
  const distanceInKm =
    parseFloat((Totaldistance || "0").replace(/[^\d.]/g, "")) || 0;

  if (!Product) return 0;

  if (Product.logic === 2) {
    return Math.round(distanceInKm * (Headers?.kmCharges || 0) + (NightCharges || 0));
  }

  if (!selectedHourNumber || !selectedDate) return 0;

  if (Product.day && Product.day !== 0) {
    return Math.round((selectedHourNumber / 24) * Product.day + NightCharges);
  }

  return Math.round(calculateHourlyPrice(selectedHourNumber));
};


const getPromoDiscountAmount = (amount) => {
  if (!promoCodeInfo?.type || !promoCodeInfo?.discount || !amount) return 0;

  const discount =
    promoCodeInfo.type === "percentage"
      ? Math.round(amount * Number(promoCodeInfo.discount))
      : Math.round(Number(promoCodeInfo.discount));

  return Math.min(Math.max(discount, 0), amount);
};

const formatPromoDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getPromoValidityText = () => {
  const start = formatPromoDate(promoCodeInfo?.startDate);
  const end = formatPromoDate(promoCodeInfo?.endDate);
  const remainingUses = promoCodeInfo?.remainingUses;
  const remainingUserUses = promoCodeInfo?.remainingUserUses;
  const details = [];

  if (start && end) details.push(`Valid ${start} to ${end}`);
  else if (start) details.push(`Valid from ${start}`);
  else if (end) details.push(`Valid till ${end}`);

  if (remainingUses !== null && remainingUses !== undefined) {
    details.push(`${remainingUses} use${Number(remainingUses) === 1 ? "" : "s"} left`);
  }

  if (remainingUserUses !== null && remainingUserUses !== undefined) {
    details.push(`${remainingUserUses} use${Number(remainingUserUses) === 1 ? "" : "s"} left for you`);
  }

  return details.join(" · ");
};

const handleProductPromoApply = async () => {
  const code = productPromoCode.trim();

  if (!code) {
    toast.error("Enter coupon code");
    return;
  }

  const promoData = await applyPromoCode(code);
  if (promoData) {
    setProductPromoCode(code);
  }
};

const handleProductPromoRemove = () => {
  setProductPromoCode("");
  removePromoCode();
};

useEffect(() => {
  setTimeSlots(generateTimeSlots(selectedDate));
  setSelectedTime('');
}, [selectedDate]);

 
// useEffect(() => {
//   if (Headers && selectedTime !== '') {
//     const nightCharges = Headers?.nightCharges ?? 0;
//     const startNightTime = Headers?.startNightTime ?? '22:00:00'; // default
//     const endingNightTime = Headers?.endingNightTime ?? '24:00:00'; // default

//     // Convert selectedTime ('11:19 PM') to 24-hour format using Date
//     const [time, modifier] = selectedTime.split(' ');
//     let [hours, minutes] = time.split(':').map(Number);

//     if (modifier === 'PM' && hours !== 12) hours += 12;
//     if (modifier === 'AM' && hours === 12) hours = 0;

//     const selectedTime24 = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;

//     // Compare times (all in string format: 'HH:MM:SS')
//     if (selectedTime24 >= startNightTime && selectedTime24 <= endingNightTime) {
//       setNightCharges(nightCharges);
//       console.log('✅ Night charges apply:', nightCharges);
//       // toast.success(`Night charges: ₹${nightCharges}`);
//     } else {
//         setNightCharges(0);
//       console.log('🌙 No night charges.');
//       // toast.success('No night charges.');
//     }
//   } else {
//       setNightCharges(0);
//     // toast.error(selectedTime ?? '');
//   }
// }, [Headers, selectedTime]);


useEffect(() => {
  if (Headers && selectedTime !== "" && selectedDate && selectedHour) {
    const startNightTime = Headers?.startNightTime ?? "22:00:00";
    const endingNightTime = Headers?.endingNightTime ?? "24:00:00";

    const selectedTime24 = convertTo24Hour(selectedTime);
    const serviceStart = new Date(`${selectedDate}T${selectedTime24}`);

    const durationHours = Number(selectedHour);
    const serviceEnd = new Date(
      serviceStart.getTime() + durationHours * 60 * 60 * 1000
    );

    const nightHoursOverlap = getNightHoursOverlap(
      serviceStart,
      serviceEnd,
      startNightTime,
      endingNightTime
    );

    let totalNightCharge = 0;

    if (Product.logic === 1) {
      // Days wala flow — flat one-time charge, hours/days se multiply nahi
      const outstationNightCharge = Headers?.outstationNightCharges ?? 0;
      totalNightCharge = nightHoursOverlap > 0 ? outstationNightCharge : 0;
    } else {
      // Hourly flow — jaisa pehle tha, per-hour multiply
      const nightChargePerHour = Headers?.nightCharges ?? 0;
      totalNightCharge = Math.round(nightHoursOverlap * nightChargePerHour);
    }

    setNightCharges(totalNightCharge);
  } else {
    setNightCharges(0);
  }
}, [Headers, selectedTime, selectedDate, selectedHour, Product.logic]);

     useEffect(() => {
        if(Headers){
setStartTime(`T${Headers?.startTime || "10:00:00" }`);
setEndTime(`T${Headers?.endTime || "20:00:00"}`);
setExtendDate(Headers?.noOfDays || 6);
setTimeGap(Headers?.timeGap || 30);
generateTimeSlots(generateDates()[0].value);
setroundOffTime(Headers?.roundOffTime || 'Yes');
setStartingHour(Headers?.startingHour || 1);
setTimeSlots(generateTimeSlots(selectedDate));
  setSelectedTime('');
        }
console.log('HeadersHeadersHeaders',Headers)
  }, [Headers]); // This useEffect will re-run whenever id changes

    
  

  return (
    <>

 {ConfirmLocation && (
  <>
    {/* Background Overlay */}
    {/* <div className="custom-overlay " onClick={() => setConfirmLocation(false)} style={{backdropFilter:'none'}}></div> */}

    {/* Bottom Sheet */}
    <div className="custom-bottom-sheet shadow-lg pb-2" style={{maxHeight:'50vh'}}>
      
     <h4 className="fw-bold mb-4 heading-fixed" onClick={() => setConfirmLocation(false)} type="button">
       {!isLoading ? Product.title || 'Not Found' : ''}
      </h4>

      {/* Close Button */}
      <div className="close-btn" onClick={() => setConfirmLocation(false)}>
        ✕
      </div>

<div className="h-100 overflow-y-scroll custom-scroll pe-2">

   
 
      <div className="w-100 px-0">
  <h5>When should the Driver arrive?</h5>
<p>Service will take approx. {duration ?? '0 mins'}</p>

<ul className="customradio input-group two-grid mb-4 px-0 mx-0">
  {generateDates().map((date) => (
    <li key={date.value}>
      <input
        type="radio"
        id={`date-${date.value}`}
        name="bookingDate"
        value={date.value}
        checked={selectedDate === date.value}
        // onChange={() => setSelectedDate(date.value)}
        onChange={() => {
  setSelectedDate(date.value);
  setTimeout(() => {
    timeRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 100);
}}
      />
      <label htmlFor={`date-${date.value}`}>
        {date.label}
      </label>
    </li>
  ))}
</ul>

<div ref={timeRef}>
  <style>{`
    .ride-booking-card {
      background: #ffffff;
      border: 1px solid #e8edf3;
      border-radius: 18px;
      box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
      padding: 14px;
      margin-bottom: 16px;
    }

    .ride-booking-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 13px;
    }

    .ride-booking-head p {
      margin: 0 0 3px;
      color: #0a9f45;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 900;
      text-transform: uppercase;
    }

    .ride-booking-head h5 {
      margin: 0;
      color: #111827;
      font-size: 17px;
      line-height: 1.25;
      font-weight: 900;
    }

    .ride-booking-icon {
      width: 42px;
      height: 42px;
      border-radius: 15px;
      background: #111827;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 42px;
      font-size: 20px;
    }

    .ride-form-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .ride-select-field {
      border: 1px solid #e5e7eb;
      border-radius: 16px;
      background: #f9fafb;
      padding: 10px 12px;
    }

    .ride-select-field.active {
      border-color: #b0833a;
      background: #f8fbff;
      box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
    }

    .ride-select-field label {
      display: block;
      margin-bottom: 6px;
      color: #6b7280;
      font-size: 11px;
      font-weight: 900;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .ride-select-control {
      position: relative;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .ride-select-control i {
      color: #b0833a;
      font-size: 18px;
      flex: 0 0 auto;
    }

    .ride-select-control select {
      width: 100%;
      border: 0;
      outline: 0;
      background: transparent;
      color: #111827;
      font-size: 15px;
      font-weight: 800;
      min-height: 30px;
      padding: 0 28px 0 0;
      appearance: none;
    }

    .ride-textarea-control {
      width: 100%;
      border: 0;
      outline: 0;
      resize: vertical;
      min-height: 82px;
      border-radius: 14px;
      background: #ffffff;
      color: #111827;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.45;
      padding: 12px 14px;
    }

    .ride-textarea-control:focus {
      box-shadow: inset 0 0 0 1px #111827;
    }

    .ride-select-control .ri-arrow-down-s-line {
      position: absolute;
      right: 0;
      color: #0a9f45;
      font-size: 22px;
      pointer-events: none;
    }

    .ride-coupon-card {
      background: #ffffff;
      border: 1px dashed #b7c7dc;
      border-radius: 18px;
      box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
      padding: 13px;
      margin-bottom: 16px;
    }

    .ride-coupon-row {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 8px;
      align-items: center;
    }

    .ride-coupon-input {
      min-width: 0;
      height: 46px;
      border: 1px solid #e5e7eb;
      border-radius: 14px;
      background: #f9fafb;
      padding: 0 13px;
      color: #111827;
      font-size: 14px;
      font-weight: 800;
      text-transform: uppercase;
      outline: 0;
    }

    .ride-coupon-btn {
      height: 46px;
      border: 0;
      border-radius: 14px;
      padding: 0 15px;
      background: #b0833a;
      color: #ffffff;
      font-size: 13px;
      font-weight: 900;
    }

    .ride-coupon-btn.remove {
      background: #fee2e2;
      color: #dc2626;
    }

    .ride-coupon-status {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin-top: 10px;
      color: #147f3c;
      font-size: 12px;
      font-weight: 800;
    }

    .ride-price-card {
      background: #0f172a;
      color: #ffffff;
      border-radius: 18px;
      padding: 14px;
      margin-bottom: 16px;
      box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
    }

    .ride-price-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.74);
      margin-bottom: 7px;
    }

    .ride-price-line strong {
      color: #ffffff;
    }

    .ride-price-total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.14);
      padding-top: 10px;
      margin-top: 8px;
      font-size: 15px;
      font-weight: 900;
    }

    .ride-receiver-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-top: 14px;
      padding: 12px 14px;
      border: 1px solid #dbeafe;
      border-radius: 14px;
      background: #eff6ff;
    }

    .ride-receiver-card p {
      margin: 0;
      color: #1e293b;
      font-size: 13px;
      font-weight: 800;
    }

    .ride-receiver-card span {
      display: block;
      margin-top: 2px;
      color: #64748b;
      font-size: 12px;
      font-weight: 600;
    }

    .ride-receiver-btn {
      flex-shrink: 0;
      border: 0;
      border-radius: 999px;
      background: #1d4ed8;
      color: #fff;
      padding: 8px 12px;
      font-size: 12px;
      font-weight: 900;
    }

    .ride-receiver-popup-backdrop {
      position: fixed;
      inset: 0;
      z-index: 1100;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 18px;
      background: rgba(15, 23, 42, 0.56);
    }

    .ride-receiver-popup {
      width: min(420px, 100%);
      border-radius: 18px;
      background: #fff;
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
      overflow: hidden;
    }

    .ride-receiver-popup-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 16px 18px;
      background: #0f172a;
      color: #fff;
    }

    .ride-receiver-popup-head h5 {
      margin: 0;
      color: #fff;
      font-size: 16px;
      font-weight: 900;
    }

    .ride-receiver-close {
      border: 0;
      background: rgba(255, 255, 255, 0.12);
      color: #fff;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      font-size: 18px;
      line-height: 1;
    }

    .ride-receiver-popup-body {
      padding: 18px;
    }

    .ride-receiver-popup-body label {
      display: block;
      margin-bottom: 7px;
      color: #475569;
      font-size: 12px;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: .05em;
    }

    .ride-receiver-input {
      width: 100%;
      height: 44px;
      border: 1.5px solid #dbe3ef;
      border-radius: 12px;
      padding: 0 13px;
      color: #111827;
      font-size: 14px;
      font-weight: 700;
      outline: none;
    }

    .ride-receiver-input:focus {
      border-color: #1d4ed8;
      box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.12);
    }

    .ride-receiver-actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 16px;
    }

    .ride-receiver-save,
    .ride-receiver-cancel {
      border: 0;
      border-radius: 10px;
      padding: 9px 14px;
      font-size: 13px;
      font-weight: 900;
    }

    .ride-receiver-save {
      background: #1d4ed8;
      color: #fff;
    }

    .ride-receiver-cancel {
      background: #f1f5f9;
      color: #475569;
    }

    @media (min-width: 560px) {
      .ride-form-grid {
        grid-template-columns: 1fr 1fr;
      }
    }
  `}</style>

  <div className="ride-booking-card">
    <div className="ride-booking-head">
      <div>
        <p>Ride setup</p>
        <h5>Choose timing and car type</h5>
      </div>
      <span className="ride-booking-icon">
        <i className="ri-steering-2-line" />
      </span>
    </div>

    <div className="ride-form-grid">
      <div className={`ride-select-field ${selectedTime ? "active" : ""}`}>
        <label>Select start time</label>
        <div className="ride-select-control">
          <i className="ri-time-line" />
          <select
            name="bookingTime"
            value={selectedTime}
            onChange={(e) => {
              setSelectedTime(e.target.value);
          
            }}
          >
            <option value="">Start time</option>
            {timeSlots.map((slot) => (
              <option key={slot} value={slot}>{slot}</option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line" />
        </div>
      </div>

      <div className={`ride-select-field ${selectedCarType ? "active" : ""}`}>
        <label>Select car type</label>
        <div className="ride-select-control">
          <i className="ri-roadster-line" />
          <select
            name="carType"
            value={selectedCarType}
            onChange={(e) => {
  setSelectedCarType(e.target.value);

  setTimeout(() => {
    hourRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, 100);
}}
          >
            <option value="">Car type</option>
            {carTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line" />
        </div>
      </div>
    </div>

    <div className="ride-receiver-card">
      <div>
        <p>Booking for someone else?</p>
        <span>{alternativePhone ? `Alternative phone: ${alternativePhone}` : "Add Phone No."}</span>
      </div>
      <button type="button" className="ride-receiver-btn" onClick={openReceiverDetails}>
        Add Phone No.
      </button>
    </div>
  </div>

  {showReceiverDetails && (
    <div className="ride-receiver-popup-backdrop" role="dialog" aria-modal="true">
      <div className="ride-receiver-popup">
        <div className="ride-receiver-popup-head">
          <h5>Add Recevier details</h5>
          <button type="button" className="ride-receiver-close" onClick={() => setShowReceiverDetails(false)}>
            x
          </button>
        </div>
        <div className="ride-receiver-popup-body">
          <label>Alternative Phone</label>
          <input
            className="ride-receiver-input"
            type="tel"
            value={receiverPhoneDraft}
            onChange={(e) => setReceiverPhoneDraft(e.target.value)}
            placeholder="Enter alternative phone"
          />
          <div className="ride-receiver-actions">
            <button type="button" className="ride-receiver-cancel" onClick={() => setShowReceiverDetails(false)}>
              Cancel
            </button>
            <button type="button" className="ride-receiver-save" onClick={saveReceiverDetails}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  )}

  <div className="ride-coupon-card">
    <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
      <div>
        <p className="small text-uppercase fw-bold text-primary mb-0">Coupon code</p>
        <h6 className="fw-bold mb-0">Apply offer</h6>
      </div>
      <i className="ri-coupon-3-line fs-4 text-primary"></i>
    </div>

    <div className="ride-coupon-row">
      <input
        className="ride-coupon-input"
        type="text"
        placeholder="Enter code"
        value={productPromoCode}
        onChange={(e) => setProductPromoCode(e.target.value)}
        disabled={promoCodeInfo?.type && promoCodeInfo?.discount > 0}
      />
      {promoCodeInfo?.type && promoCodeInfo?.discount > 0 ? (
        <button type="button" className="ride-coupon-btn remove" onClick={handleProductPromoRemove}>
          Remove
        </button>
      ) : (
        <button type="button" className="ride-coupon-btn" onClick={handleProductPromoApply}>
          Apply
        </button>
      )}
    </div>

    {promoCodeInfo?.type && promoCodeInfo?.discount > 0 && (
      <>
      <div className="ride-coupon-status">
        <span>
          <i className="ri-checkbox-circle-fill me-1"></i>
          {mypromoCode} applied
        </span>
        <span>
          {promoCodeInfo.type === "percentage"
            ? `${promoCodeInfo.discount * 100}% OFF`
            : `₹${promoCodeInfo.discount} OFF`}
        </span>
      </div>
      {getPromoValidityText() && (
        <p className="small text-muted mb-0 mt-2">{getPromoValidityText()}</p>
      )}
      </>
    )}
  </div>
</div>

<div ref={hourRef}>
 
{Product.logic !== 2 ? (

(Product.logic === 1  ) ?
<>


<p className="mt-3 text-uppercase border-bottom pb-2 fw-bold">Select service days</p>

 <ul className="customradio input-group two-grid mb-4 px-0 mx-0">
   {[24, 48, 72, 96, 120,144,168,192,216,240,264,288,312,336,360].map((hour) => (
    <li key={hour}>
      <input
        type="radio"
        id={`hour-${hour}`}
        name="bookingHour"
        value={hour}
        checked={selectedHour === String(hour)}
        // onChange={() => selectChangeHour(hour)} // Ensure state updates

        onChange={() => {
  selectChangeHour(hour);
  setTimeout(() => {
    priceRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 100);
}}

      />
      <label htmlFor={`hour-${hour}`}> {hour === 24 ? 'Full Day' : hour === 0.5 ? '30min' : (hour /24) + ' days'} </label>
    </li>
  ))}
</ul>

<div className={`ride-select-field mb-4 ${pickupFullAddress ? "active" : ""}`}>
  <label htmlFor="pickupFullAddress">Pickup Full Address</label>
  <textarea
    id="pickupFullAddress"
    className="ride-textarea-control"
    rows={3}
    value={pickupFullAddress}
    onChange={(event) => setPickupFullAddress(event.target.value)}
    placeholder="Enter pickup full address"
  />
</div>


<div ref={priceRef} style={{display:'none'}}> 
{NightCharges !== 0 && <p className="small text-danger mb-2"> Night Charges Added</p>}
{(selectedHour !== '' && selectedDate !== '') && <h5 className="fw-bold"> Approx Price : 
  <span className="text-danger"> ₹{selectedHour === 0.5 ? ProductsSale + NightCharges : ((selectedHour/24) *Product.day)  + NightCharges }  </span></h5>
 }
</div>
    
</> :
<>
<p className="mt-3 text-uppercase border-bottom pb-2 fw-bold">Select service hour</p>
<div className={`ride-select-field mb-4 ${selectedHour ? "active" : ""}`}>
  <div className="ride-select-control">
    <i className="ri-time-line" />
    <select
      name="bookingHour"
      value={selectedHour}
      onChange={(event) => {
        selectChangeHour(event.target.value);
        setTimeout(() => {
          priceRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }}
    >
      <option value="">Select service hour</option>
      {Array.from({ length: 22 }, (_, i) => {
        const baseHour = Headers.serviceHour / 60;
        const hour = baseHour + i;
        return (
          <option key={hour} value={hour}>
            {hour === 24 ? "Full Day" : `${hour}Hr`}
          </option>
        );
      })}
    </select>
    <i className="ri-arrow-down-s-line" />
  </div>
</div>

<div className={`ride-select-field mb-4 ${pickupFullAddress ? "active" : ""}`}>
  <label htmlFor="pickupFullAddress">Pickup Full Address</label>
  <textarea
    id="pickupFullAddress"
    className="ride-textarea-control"
    rows={3}
    value={pickupFullAddress}
    onChange={(event) => setPickupFullAddress(event.target.value)}
    placeholder="Enter pickup full address"
  />
</div>

<div ref={priceRef}>
 
{NightCharges !== 0 && <p className="small text-danger mb-2"> Night Charges Added</p>}

{(selectedHour !== '' && selectedDate !== '') && <h5 className="fw-bold"  style={{display:'none'}} > Approx Price : <span className="text-danger"> ₹{selectedHour === 0.5 ? ProductsSale + NightCharges: ProductsSale + ((selectedHour*60 - 30) *Product.minPrice) + NightCharges}  </span></h5>
   }
</div>
</> ) : 
<>
 
{( selectedDate !== '' && selectedTime !== '') && <h5 className="fw-bold">  
   Approx Price :{" "} 
    <span className="text-danger">
      ₹{(((parseFloat((Totaldistance || "0").replace(/[^\d.]/g, ""))) || 0) * Headers.kmCharges) + (NightCharges || 0)}
    </span>
    </h5>
 }
</>
}
</div>

{getApproxPrice() > 0 && (
  <div className="ride-price-card" ref={priceRef}>
   <div className="ride-price-line">
  <span>Approx fare</span>
  <strong>Rs. {getApproxPrice() - NightCharges}</strong>
</div>
    {NightCharges !== 0 && (
      <div className="ride-price-line">
        <span>Night charges included</span>
        <strong>Rs. {NightCharges}</strong>
      </div>
    )}
    {getPromoDiscountAmount(getApproxPrice()) > 0 && (
      <div className="ride-price-line">
        <span>Coupon discount</span>
        <strong>- Rs. {getPromoDiscountAmount(getApproxPrice())}</strong>
      </div>
    )}
    <div className="ride-price-total">
      <span>Approx now</span>
      <span>
        Rs. {Math.max(0, getApproxPrice() - getPromoDiscountAmount(getApproxPrice()))}
      </span>
    </div>
  </div>
)}

<p>
  In case of only dropping the client out of the city, the driver must be provided the return bus or train fare extra on the decided driver service charge. Please note - the charges may vary in cases of long distance droppings / one way trips only (i.e. 500kms and above).

  <br /><br />

  Conveyance charges will be applicable if the client is not dropped to the same point he/she is picked from.

  <br /><br />

  In case of queries regarding charges of one way dropping please feel free to call us on{" "}
  <a href={`tel:${Headers?.phone}`} className="text-success">
    {Headers?.phone}
  </a>
</p>

  </div>
 
<div className=" position-sticky bottom-0 bg-white d-flex gap-2 pt-2 shadow">

<button
  className="btn bg-dark text-white d-flex align-items-center justify-content-center  fw-light col-4"
  type="button"
  onClick={() => setConfirmLocation(false)}
>
 <i class="ri-arrow-left-line"/>
  <span className="d-sm-inline ms-2 text-white">Back</span>
</button>


   <button
                        // disabled={Product?.stock === 0}
                          className="btn bg-primary text-white d-flex align-items-center justify-content-center w-100 fw-light"
                          type="button"
                          onClick={() => {
                                           const myprice =  
                                           Product.logic !== 2 ? ( (Product.day && Product.day !== 0  ) ? (
selectedHour === 0.5 ? ProductsSale: ((selectedHour/24) *Product.day) 
) : selectedHour === 0.5 ? ProductsSale: ProductsSale + ((selectedHour*60 - 30) *Product.minPrice)) : (((parseFloat((Totaldistance || "0").replace(/[^\d.]/g, ""))) || 0) * Headers.kmCharges) + (NightCharges || 0) ;
//  const GSTPrice =  Math.round((myprice+NightCharges ) * 1.18) ; 
 const GSTPrice =  Math.round(myprice) ; 

                            if (Product.type) {
                              if (ProductsSale === 0) {
                                toast.error("Please Choose Attribute");
                              } else {
                                   if(!selectedDate){
                                 toast.error('Select Date');
                                       return;
                              }
                              if(!selectedTime){
                                toast.error('Select Time');
                                return;
                              }
                              if(!selectedCarType){
                                toast.error('Select Car Type');
                                return;
                              }
                             if(!selectedHour){
                                   toast.error('Select Service Hour');
                                return;
                              }
                                handleAddToCart({
                                  id: Product._id + ProductuniqueId,
                                  title: Product.title + ProductVariantName,
                                  image:
                                    MatchImages.length !== 0
                                      ? MatchImages[0].src
                                      : frontImage, // Remove the extra dot
                                  regularPrice: ProductsRegular + myprice,
                                  salePrice: Product.salePrice,
                                  price: myprice,
                                  color: selectedColor,
                                  customise: pdfBase64,
                                  TotalQuantity: TotalQuantity,
                                  SelectedSizes: SelectedSizes,
                                  weight: Product.weight,
                                  gst: 0,
                                  stock: Product.stock,
                                  pid: Product._id,
                                date: selectedDate,
                                time: selectedTime,
                                hour: selectedHour,
                                GSTPrice: GSTPrice,
                                carType: selectedCarType,
                                alternativePhone: alternativePhone.trim(),
                                pickupFullAddress: pickupFullAddress.trim() || selectedLocation,
                               NightCharges : NightCharges ,
                               fullday : Product.day,
                             minPrice : Product.minPrice,
                             pickup: selectedLocation,
                             dropoff: dropoffLocation,
distanceKm: Number(
  (parseFloat((Totaldistance || "0").replace(/[^\d.]/g, "")) || 0).toFixed(2)
), 
                             pickupMeta,
                                quantity:1,
                                dropoffMeta,
                                  logic: Product.logic
                                });
                              }
                            } else {
                        if(!selectedDate){
                                 toast.error('Select Date');
                                       return;
                              }
                              if(!selectedTime){
                                toast.error('Select Time');
                                return;
                              }
                              if(!selectedCarType){
                                toast.error('Select Car Type');
                                return;
                              }
                               if(!selectedHour && Product.logic !== 2){
                                   toast.error('Select Hour');
                                return;
                              }
                              handleAddToCart({
                                id: Product._id + ProductuniqueId,
                                title: Product.title + ProductVariantName,
                                image:
                                  MatchImages.length !== 0
                                    ? MatchImages[0].src
                                    : frontImage, // Remove the extra dot
                                regularPrice: ProductsRegular+myprice,
                                 salePrice: Product.salePrice,
                                 price: myprice,

                                // price: ProductsSale,
                                color: selectedColor,
                                customise: pdfBase64,
                                TotalQuantity: TotalQuantity,
                                SelectedSizes: SelectedSizes,
                                weight: Product.weight,
                                gst: 0,
                                stock: Product.stock,
                                pid: Product._id,
                                date: selectedDate,
                                time: selectedTime,
                                hour: selectedHour,
                                GSTPrice: GSTPrice,
                                carType: selectedCarType,
                                alternativePhone: alternativePhone.trim(),
                                pickupFullAddress: pickupFullAddress.trim() || selectedLocation,
                              NightCharges : NightCharges ,
                             fullday : Product.day,
                             minPrice : Product.minPrice,
                              quantity:1,
                               pickup: selectedLocation,
                             dropoff: dropoffLocation,
                             pickupMeta,
                             dropoffMeta,
                             distanceKm: Number(
  (parseFloat((Totaldistance || "0").replace(/[^\d.]/g, "")) || 0).toFixed(2)
), 
                             logic: Product.logic
                              });
                            }
                          }}
                        >
                          <i className="ri-shopping-cart-2-line text-white" />
                          <span className="d-sm-inline ms-2 text-white">
                            Book Now
                          </span>
                        </button>
  
</div>



    </div>


    </div>
  </>
)}



<main className="page-content ride-location-page">
  <style>{`
    .ride-location-page {
      min-height: 100vh;
      background: #f6f8fb;
      color: #111827;
    }

    .ride-location-wrap {
       margin: 0 auto;
      position: relative;
      min-height: 100vh;
      overflow: hidden;
      background: #eef3f8;
    }

    .ride-map {
      height: 100vh;
      width: 100%;
      background: #dfe8ef;
    }

    .ride-map.open-map {
      height: 62vh;
    }

    .ride-top-bar {
      position: absolute;
      z-index: 15;
      top: 14px;
      left: 14px;
      right: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      pointer-events: none;
    }

    .ride-icon-btn {
      pointer-events: auto;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      border: 0;
      background: #ffffff;
      color: #111827;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 10px 26px rgba(15, 23, 42, 0.14);
    }

    .ride-location-sheet {
      position: absolute;
      z-index: 20;
      left: 0;
      right: 0;
      bottom: 0;
      max-height: 85vh;
      overflow-y: auto;
      background: #f6f8fb;
      border-radius: 26px 26px 0 0;
      box-shadow: 0 -18px 40px rgba(15, 23, 42, 0.16);
      padding: 10px 16px calc(96px + env(safe-area-inset-bottom));
    }

    .ride-sheet-handle {
      width: 42px;
      height: 5px;
      border-radius: 999px;
      background: #cbd5e1;
      margin: 0 auto 14px;
    }

    .ride-sheet-title {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 12px;
    }

    .ride-sheet-title h1 {
      margin: 0;
      font-size: 18px;
      line-height: 1.2;
      font-weight: 800;
      color: #111827;
    }

    .ride-sheet-title p {
      margin: 4px 0 0;
      font-size: 12px;
      color: #6b7280;
    }

    .ride-status-pill {
      flex: 0 0 auto;
      border-radius: 999px;
      background: #eef2ff;
      color: #3158d4;
      font-size: 11px;
      font-weight: 800;
      padding: 7px 10px;
    }

    .ride-card {
      background: #ffffff;
      border: 1px solid #e8edf3;
      border-radius: 18px;
      box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
    }

    .ride-route-card {
      padding: 10px 12px;
      display: grid;
      grid-template-columns: 26px 1fr;
      gap: 10px;
      align-items: stretch;
    }

    .ride-route-icons {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 11px;
    }

    .ride-dot {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: #b0833a;
      box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.12);
    }

    .ride-dot.drop {
      background: #111827;
      box-shadow: 0 0 0 4px rgba(17, 24, 39, 0.12);
    }

    .ride-dash {
      flex: 1;
      min-height: 40px;
      border-left: 2px dashed #cbd5e1;
      margin: 8px 0;
    }

    .ride-field {
      min-height: 62px;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .ride-field + .ride-field {
      border-top: 1px solid #eef2f7;
    }

    .ride-field-text {
      min-width: 0;
      flex: 1;
      padding: 7px 0;
    }

    .ride-field-label {
      display: block;
      color: #6b7280;
      font-size: 11px;
      line-height: 1.2;
      font-weight: 800;
      text-transform: uppercase;
    }

    .ride-field input {
      width: 100%;
      border: 0;
      outline: 0;
      background: transparent;
      color: #111827;
      font-size: 15px;
      font-weight: 700;
      min-height: 28px;
      padding: 2px 0 0;
      overflow-wrap: anywhere;
    }

    .ride-field input::placeholder {
      color: #9ca3af;
      font-weight: 600;
    }

    .ride-clear-btn {
      width: 34px;
      height: 34px;
      flex: 0 0 34px;
      border: 0;
      border-radius: 50%;
      background: #f3f4f6;
      color: #6b7280;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .ride-section-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin: 18px 2px 10px;
    }

    .ride-section-head h2 {
      margin: 0;
      font-size: 14px;
      line-height: 1.2;
      font-weight: 800;
      color: #111827;
    }

    .ride-section-head span {
      font-size: 12px;
      color: #6b7280;
    }

    .ride-saved-scroll {
      display: flex;
      gap: 10px;
      width: 100%;
      max-width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 2px 0 6px;
      scrollbar-width: thin;
      scrollbar-color: #b0833a #e5e7eb;
      -webkit-overflow-scrolling: touch;
      scroll-behavior: smooth;
    }

    .ride-saved-scroll::-webkit-scrollbar {
      height: 8px;
      display: block;
    }

    .ride-saved-scroll::-webkit-scrollbar-track {
      background: #e5e7eb;
      border-radius: 999px;
    }

    .ride-saved-scroll::-webkit-scrollbar-thumb {
      background: #b0833a;
      border-radius: 999px;
    }

    .ride-saved-card {
      border: 1px solid #e5e7eb;
      background: #ffffff;
      flex: 0 0 192px;
      max-width: 210px;
      border-radius: 17px;
      padding: 12px;
      text-align: left;
      box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
    }

    .ride-saved-card.active {
      border-color: #b0833a;
      box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
    }

    .ride-saved-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 7px;
    }

    .ride-saved-label {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      min-width: 0;
      color: #111827;
      font-size: 13px;
      font-weight: 800;
    }

    .ride-default-badge {
      flex: 0 0 auto;
      border-radius: 999px;
      background: #e8f8ef;
      color: #147f3c;
      font-size: 10px;
      font-weight: 800;
      padding: 4px 7px;
    }

    .ride-saved-address {
      color: #6b7280;
      font-size: 12px;
      line-height: 1.35;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .ride-suggestion-list {
      overflow: hidden;
    }

    .ride-suggestion-btn {
      width: 100%;
      border: 0;
      background: #ffffff;
      text-align: left;
      display: grid;
      grid-template-columns: 38px 1fr auto;
      align-items: center;
      gap: 10px;
      padding: 13px;
      border-bottom: 1px solid #eef2f7;
    }

    .ride-suggestion-btn:last-child {
      border-bottom: 0;
    }

    .ride-suggestion-icon {
      width: 38px;
      height: 38px;
      border-radius: 13px;
      background: #f1f5f9;
      color: #b0833a;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
    }

    .ride-suggestion-main {
      display: block;
      color: #111827;
      font-size: 14px;
      line-height: 1.25;
      font-weight: 800;
      overflow-wrap: anywhere;
    }

    .ride-suggestion-sub {
      display: -webkit-box;
      margin-top: 3px;
      color: #6b7280;
      font-size: 12px;
      line-height: 1.35;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .ride-help-card {
      display: flex;
      gap: 10px;
      align-items: flex-start;
      padding: 13px;
      color: #4b5563;
      font-size: 12px;
      line-height: 1.4;
      background: #fff7ed;
      border-color: #fed7aa;
    }

    .ride-help-card i {
      color: #ea580c;
      font-size: 18px;
      margin-top: 1px;
    }

    .ride-bottom-actions {
      position: absolute;
      z-index: 25;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
      background: rgba(246, 248, 251, 0.96);
      border-top: 1px solid #e8edf3;
      backdrop-filter: blur(12px);
      display: flex;
      gap: 10px;
    }

    .ride-back-btn,
    .ride-search-btn {
      border: 0;
      min-height: 54px;
      border-radius: 17px;
      font-weight: 800;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .ride-back-btn {
      flex: 0 0 108px;
      background: #111827;
      color: #ffffff;
    }

    .ride-search-btn {
      flex: 1;
      background: #b0833a;
      color: #ffffff;
      box-shadow: 0 14px 30px rgba(13, 110, 253, 0.28);
    }

    .ride-search-btn:disabled {
      opacity: 0.58;
      box-shadow: none;
    }

    @media (max-width: 360px) {
      .ride-bottom-actions {
        padding-left: 12px;
        padding-right: 12px;
      }

      .ride-back-btn {
        flex-basis: 88px;
      }

      .ride-location-sheet {
        padding-left: 12px;
        padding-right: 12px;
      }
    }

    @media (min-width: 768px) {
      .ride-saved-scroll {
        cursor: grab;
        padding-bottom: 12px;
      }

      .ride-saved-scroll:active {
        cursor: grabbing;
      }
    }
  `}</style>

  <div className="ride-location-wrap">
    <div
      id="map"
      className={`ride-map ${ConfirmLocation ? "open-map" : ""}`}
    ></div>

    <div className="ride-top-bar">
      <Link className="ride-icon-btn" to="/" aria-label="Back">
        <i className="ri-arrow-left-line fs-5" />
      </Link>
      <button
        type="button"
        className="ride-icon-btn"
        onClick={() => loadMapScript(getZoomLevel)}
        aria-label="Refresh map"
      >
        <i className="ri-refresh-line fs-5" />
      </button>
    </div>

    {!ConfirmLocation && (
      <div className="ride-location-sheet">
        <div className="ride-sheet-handle" />

        <div className="ride-sheet-title">
          <div>
            <h1>Set Your Ride Route</h1>
            <p>Choose a saved pickup or search a new location</p>
          </div>
          <span className="ride-status-pill">
            {pickupLocationFinal && dropoffLocationFinal ? "Ready" : "Step 1"}
          </span>
        </div>

        <div className="ride-card ride-route-card">
          <div className="ride-route-icons">
            <span className="ride-dot" />
            <span className="ride-dash" />
            <span className="ride-dot drop" />
          </div>

          <div>
            <div className="ride-field">
              <div className="ride-field-text">
                <span className="ride-field-label">Pickup</span>
                <input
                  type="text"
                  placeholder="Search or choose saved pickup"
                  value={pickupLocation}
                  onChange={handlePickupChange}
                />
              </div>
              {pickupLocation && (
                <button
                  type="button"
                  className="ride-clear-btn"
                  onClick={clearPickup}
                  aria-label="Clear pickup"
                >
                  <i className="ri-close-line fs-5"></i>
                </button>
              )}
            </div>

            <div className="ride-field">
              <div className="ride-field-text">
                <span className="ride-field-label">Drop</span>
                <input
                  type="text"
                  placeholder="Where do you want to go?"
                  value={dropoffLocation}
                  onChange={handleDropoffChange}
                />
              </div>
              {dropoffLocation && (
                <button
                  type="button"
                  className="ride-clear-btn"
                  onClick={clearDrop}
                  aria-label="Clear drop"
                >
                  <i className="ri-close-line fs-5"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {savedAddresses.length > 0 && (!pickupLocationFinal || !dropoffLocationFinal) && (
          <>
            <div className="ride-section-head">
              <h2>Saved Addresses</h2>
              <span>{savedAddresses.length} saved</span>
            </div>

            <div className="ride-saved-scroll">
              {savedAddresses.map((addressData) => (
                <button
                  type="button"
                  key={addressData._id}
                  className={`ride-saved-card ${
                    (pickupLocation === addressData.address || dropoffLocation === addressData.address) ? "active" : ""
                  }`}
                  onClick={() => chooseSavedRouteAddress(addressData)}
                >
                  <span className="ride-saved-top">
                    <span className="ride-saved-label">
                      <i className="ri-map-pin-2-fill text-primary"></i>
                      {addressData.label || "Address"}
                    </span>
                    {addressData.isDefault && (
                      <span className="ride-default-badge">Default</span>
                    )}
                  </span>
                  <span className="ride-saved-address">{addressData.address}</span>
                </button>
              ))}
            </div>
          </>
        )}

        {pickupSuggestions.length > 0 && (
          <>
            <div className="ride-section-head">
              <h2>Pickup Results</h2>
              <span>Select one</span>
            </div>

            <div className="ride-card ride-suggestion-list">
              {pickupSuggestions.map((suggestion, index) => (
                <button
                  type="button"
                  className="ride-suggestion-btn"
                  key={suggestion.place_id || index}
                  onClick={() => handleSearchPickupClick(suggestion)}
                >
                  <span className="ride-suggestion-icon">
                    <i className="ri-map-pin-2-fill"></i>
                  </span>
                  <span>
                    <span className="ride-suggestion-main">
                      {suggestion.structured_formatting.main_text}
                    </span>
                    <span className="ride-suggestion-sub">
                      {suggestion.structured_formatting.secondary_text}
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line fs-4 text-muted"></i>
                </button>
              ))}
            </div>
          </>
        )}

        {dropoffSuggestions.length > 0 && (
          <>
            <div className="ride-section-head">
              <h2>Drop Results</h2>
              <span>Select one</span>
            </div>

            <div className="ride-card ride-suggestion-list">
              {dropoffSuggestions.map((suggestion, index) => (
                <button
                  type="button"
                  className="ride-suggestion-btn"
                  key={suggestion.place_id || index}
                  onClick={() => handleSearchDropClick(suggestion)}
                >
                  <span className="ride-suggestion-icon">
                    <i className="ri-record-circle-fill"></i>
                  </span>
                  <span>
                    <span className="ride-suggestion-main">
                      {suggestion.structured_formatting.main_text}
                    </span>
                    <span className="ride-suggestion-sub">
                      {suggestion.structured_formatting.secondary_text}
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line fs-4 text-muted"></i>
                </button>
              ))}
            </div>
          </>
        )}

        {savedAddresses.length === 0 && !pickupSuggestions.length && !dropoffSuggestions.length && (
          <div className="ride-card ride-help-card mt-3">
            <i className="ri-information-line"></i>
            <span>
              Add addresses from My Location to pick them instantly next time, or type a new pickup above.
            </span>
          </div>
        )}
      </div>
    )}

    <div className="ride-bottom-actions">
      <Link className="ride-back-btn" to="/">
        <i className="ri-arrow-left-line" />
        <span>Back</span>
      </Link>

      <button
        type="button"
        onClick={() => handleSearchLocationClick()}
        className="ride-search-btn"
        disabled={ConfirmLocation || !pickupLocationFinal || !dropoffLocationFinal || startSearching}
      >
        {startSearching ? (
          <div className="loaderUpDown"></div>
        ) : (
          <>
            <i className="ri-search-line"></i>
            <span>
              {pickupLocationFinal && dropoffLocationFinal
                ? "Search Ride"
                : "Select Route"}
            </span>
          </>
        )}
      </button>
    </div>
  </div>
</main>
 
  
    </>
  );
};

export default ProductSlug;
